// extracted by mini-css-extract-plugin
export default {"container":"style_container__lKDlj","text":"style_text__JPDyu","first":"style_first__Mjyif","firstAnim":"style_firstAnim__+iNP2"};